'use client'

import { ReactNode, useEffect, useState } from 'react'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'

function isProductionDomain(): boolean {
  if (typeof window === 'undefined') return false

  const productionDomain = process.env.NEXT_PUBLIC_RECAPTCHA_PRODUCTION_DOMAIN
  if (!productionDomain) return false

  const hostname = window.location.hostname
  // Check both with and without www subdomain
  return hostname === productionDomain || hostname === `www.${productionDomain}`
}

export function ReCaptchaProvider({ children }: { children: ReactNode }) {
  const [shouldLoadRecaptcha, setShouldLoadRecaptcha] = useState(false)
  const siteKey = process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY

  useEffect(() => {
    // Check domain on client-side only
    setShouldLoadRecaptcha(isProductionDomain())
  }, [])

  // Skip reCAPTCHA if not on production domain
  if (!shouldLoadRecaptcha) {
    return <>{children}</>
  }

  if (!siteKey) {
    console.warn('NEXT_PUBLIC_RECAPTCHA_SITE_KEY is not defined. reCAPTCHA will not be loaded.')
    return <>{children}</>
  }

  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={siteKey}
      scriptProps={{
        async: true,
        defer: true,
        appendTo: 'head',
      }}
    >
      {children}
    </GoogleReCaptchaProvider>
  )
}

// Export helper for use in other components
export { isProductionDomain }
